import { Check, CheckCheck, Clock, AlertCircle } from "lucide-react";
import { MESSAGE_STATUS } from "../constants";

export default function MessageFooter({ status, timestamp, isOutbound, className = "" }) {
  const getStatusIcon = () => {
    if (!isOutbound) return null;

    switch (status) {
      case MESSAGE_STATUS.QUEUED:
        return <Clock className="h-3.5 w-3.5 text-gray-400 dark:text-slate-500" />;
      case MESSAGE_STATUS.SENT:
        return <Check className="h-3.5 w-3.5 text-gray-400 dark:text-slate-500" />;
      case MESSAGE_STATUS.DELIVERED:
        return <CheckCheck className="h-3.5 w-3.5 text-gray-400 dark:text-slate-500" />;
      case MESSAGE_STATUS.READ:
        return <CheckCheck className="h-3.5 w-3.5 text-blue-500 dark:text-blue-400" />;
      case MESSAGE_STATUS.FAILED:
        return <AlertCircle className="h-3.5 w-3.5 text-red-500 dark:text-red-400" />;
      default:
        return null;
    }
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    try {
      const normalizedTimestamp =
        Number(timestamp) > 9999999999 ? Number(timestamp) : Number(timestamp) * 1000;
      const date = new Date(normalizedTimestamp);
      return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } catch {
      return "";
    }
  };

  const timeLabel = formatTime(timestamp);
  const statusIcon = getStatusIcon();

  if (!timeLabel && !statusIcon) {
    return null;
  }

  return (
    <div className={`mt-1 flex justify-end ${className}`.trim()}>
      <div className="inline-flex items-center gap-1 whitespace-nowrap leading-none">
      <span className="text-[10px] text-gray-500 dark:text-slate-400 font-medium">
        {timeLabel}
      </span>
      {statusIcon}
      </div>
    </div>
  );
}
